import React from 'react';
import i18next from 'i18next';
import { Row } from '../Table';
import { entries } from 'common_util_node/util';
import styled from 'styled-components';
import { colors } from '../../../styles/colors';

type Props = {
  row: Row;
};

export class TableHeader extends React.PureComponent<Props> {
  render() {
    const { row } = this.props;
    return <HeaderRow className="TableHeader">
      {
        entries(row).map(([key, value]) => <th key={key} className={`cell ${key}`}>{i18next.t(value as string)}</th>)
      }
    </HeaderRow>;
  }
}

const HeaderRow = styled.tr`
  font-size: 0.9em;
  font-weight: bold;
  height: 1.5rem;

  .cell {
    color: ${colors.textLight};
  }
`;
